<template>
	<div class="root">
		<div v-show="!showPayCode">
			<MeetingHeader/>
			<div class="container">
				<div class="header">
					<img class="room-img" :src="getRoomImage(orders)">
					<div class="countDown" v-if="orders[0] && orders[0].OrderStatus == 'UnPay' && countTimer">
						剩余时间：<span>{{ countDownTime[0] }}</span>:<span>{{ countDownTime[1] }}</span>:<span>{{ countDownTime[2] }}</span>
					</div>
					<div class="h-middle">
						<h3 class="meeting-center">{{ StoreName }}</h3>
						<div class="order-desc" v-for="(item,ordersIndex) in orders" :key="ordersIndex">
							<div class="meeting-room">{{ item.IsRoom ? item.RoomName : `${item.ProductName}&nbsp;×&nbsp;${item.Qty}` }}</div>
							<div class="timerange" v-if="item.IsRoom">{{ item.BookingDate }} {{ item.BeginTime }} - {{ item.EndTime }}</div>
							<div class="money" v-if="item.RoomName || item.ProductName">￥{{ item.Price * item.Qty }}</div>
							<div :class="getOrderStatusStr('tag',item.DetailOrderStatus)" v-if="!(item.DetailOrderStatus == 'UnPay')">{{ getOrderStatusStr('text',item.DetailOrderStatus) }}</div>
						</div>
						<div class="orderno"><b>订单编号: {{ orderno }}</b></div>
					</div>
					<div class="h-right">
						应付金额<span class="total">￥{{amount}}元</span>
					</div>
				</div>
				<div class="payList">
					<div class="item" @click="swtichPayChannel(item.payChannel)" v-for="(item,payListIndex) in payList" :key="payListIndex">
						<div class="left">
							<img :src="item.src">
							<b v-html="item.text"></b>
						</div>
						<img v-if='payChannel==item.payChannel' class="right" src="@/assets/order/hook.png">
					</div>
				</div>
				<!-- <div class="qrcode" v-show='showPayCode'>
					<img :src='QRImg'>
				</div> -->
			</div>
			<div class="bottom">
				<Button @click='goPay' size='large' class='pay-btn' type='primary' :loading="loading" :disabled="!countTimer">{{ countTimer ? '支付' : '已超时'}}</Button>
			</div>
		</div>

		<!-- 支付宝引导页面 -->
		<transition name="fade">
			<div v-show="showAlipayGuide" class="alipay-guide">
				<div class="guide-content">
					<div class="guide-header">
						<h3>支付宝支付</h3>
						<div class="close-btn" @click="closeAlipayGuide">×</div>
					</div>
					<div class="guide-body">
						<div class="step-section">
							<div class="step-item">
								<div class="step-number">1</div>
								<div class="step-content">
									<h4>点击下方按钮复制支付链接</h4>
									<p>由于微信限制，需要在手机浏览器中完成支付宝支付</p>
								</div>
							</div>
							<div class="step-item">
								<div class="step-number">2</div>
								<div class="step-content">
									<h4>打开手机浏览器</h4>
									<p>粘贴链接到 Safari、Chrome 或其他浏览器</p>
								</div>
							</div>
							<div class="step-item">
								<div class="step-number">3</div>
								<div class="step-content">
									<h4>完成支付</h4>
									<p>在浏览器中按照提示完成支付宝支付</p>
								</div>
							</div>
						</div>
						<div class="action-buttons">
							<Button type="primary" size="large" @click="copyToClipboard" class="guide-btn">复制支付链接</Button>
							<Button size="large" @click="closeAlipayGuide" class="guide-btn secondary">选择其他支付方式</Button>
						</div>
						<div class="order-info">
							<p><strong>订单编号:</strong> {{ orderno }}</p>
							<p><strong>支付金额:</strong> ￥{{ amount.toFixed(2) }}元</p>
						</div>
					</div>
				</div>
			</div>
		</transition>

		<transition name="fade">
			<div v-show='showPayCode' class="qrcode-bg">
				<div class='desc'>
					<div class="top">
						<p>请您及时付款，以便订单尽快处理！订单号：{{orderno}}</p>
						<p>Please pay timely! Order number: {{orderno}}</p>
						<br>
						<!-- <p>请您在提交订单后尽快完成支付, 否则订单将{{remaining.hour}}:{{remaining.minute}}:{{remaining.second}}后取消。</p>
						<p>Please pay timely, time for payment left: {{remaining.hour}}:{{remaining.minute}}:{{remaining.second}}</p>
						<br> -->
						<p>应付金额:<b>{{amount.toFixed(2)}}</b>元</p>
						<p>Total:<b>{{amount.toFixed(2)}}</b>Yuan</p>
					</div>
					<div class="main">
						<div class="qrcode">
							<img :src='QRImg'>
							<div class="qrcode-desc">
								<template v-if='payChannel=="wechat"'>
									<p>请使用微信扫一扫<b>(Use Wechat to scan)</b></p>
									<p>扫描二维码支付<b>(Scan the code to pay)</b></p>
								</template>
								<template v-if='payChannel=="together"'>
									<p>请使用支付软件扫一扫<b>(Use software to scan)</b></p>
									<p>扫描二维码支付<b>(Scan the code to pay)</b></p>
								</template>
								<template v-if='payChannel=="alipay"'>
									<p>请使用支付宝扫一扫<b>(Use AliPay to scan)</b></p>
									<p>扫描二维码支付<b>(Scan the code to pay)</b></p>
								</template>
							</div>
						</div>
						<div class='p-w-sidebar' :class="{wechat:payChannel=='wechat',alipay:payChannel=='alipay',jhzf:payChannel=='together'}"></div>
					</div>
				</div>
				<div class="close">
					<svg width="60" height="60" style='cursor: pointer;' @click='colse'>
						<circle cx="30" cy="30" r="25" stroke="#636363" stroke-width="2" fill="none" />
						<line x1="22" y1="38" x2="38" y2="22" style="stroke:#636363;stroke-width:2" />
						<line x1="22" y1="22" x2="38" y2="38" style="stroke:#636363;stroke-width:2" />
					</svg>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex'
	import MeetingHeader from '@/components/header/MeetingHeader'
	import { baseUrl, cvoUrl, ambaseUrl } from "@/config/env";

	import wechat from '@/assets/order/wechat.png'
	import manyPay from '@/assets/order/manyPay.png'
	import alipay from '@/assets/order/alipay.png'
	import unionpay from '@/assets/order/unionpay.png'
	import util from "@/config/util"

	export default {
		data() {
			return {
				payChannel: 'wechat', // 默认微信支付，1:支付宝、20:微信、3:银联支付、4:扫码支付
				payList: [],
				isWeChatBrowser: false, // 判断是否微信环境
				isAPPBrowser: false, // 判断是否香荟APP环境
				showAlipayGuide: false, // 支付宝引导页面
				countNum: 0,
				showPayCode: false,
				ajaxpay: null,
				orders:[],
				orderno:null,
				QRImg:null, // 支付二维码
				StoreName:null,
				loading:false,
				countDownTime:['00','10','00'],
				countTimer:null,
				TimeExpire:null,
				unpayTimeoutMinutes: 0,
				pageShowHandler: null,
				visibilityHandler: null,
				isResumingFromReturn: false,
			}
		},
		created() {
			this.$nextTick(function() {
				this.detectBrowser()
				this.initData()
			})
			// 从支付页返回（尤其是 bfcache）时，强制刷新倒计时
			this.pageShowHandler = async () => {
				await this.resumePageState()
			}
			this.visibilityHandler = async () => {
				if (document.visibilityState === 'visible') {
					await this.resumePageState()
				}
			}
			window.addEventListener('pageshow', this.pageShowHandler)
			document.addEventListener('visibilitychange', this.visibilityHandler)
		},
		async activated() {
			await this.resumePageState()
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
			MeetingHeader,
		},
		computed: {
			...mapState({
				userInfo: state => state.common.userInfo,
			}),
			amount(){
				const cartSum = this.orders.filter(item => item.OrderStatus?.toLowerCase() === 'unpay').reduce((total, item) => total + ((item.Qty * item.Price) || 0), 0);
				return cartSum
			},
		},
		methods: {
			...mapActions([
				'getReservationOrdersAction',
				'getReservationDetailAction',
				'getQRcodeAction',
				'getMeetingOrderStatusAction',
				'getMeetingOrderTimeAction'
			]),
			yyyyMMddHHmmss(ts){
				const date = new Date(ts);
				const pad = n => n.toString().padStart(2, '0');

				const yyyy = date.getFullYear();
				const MM = pad(date.getMonth() + 1);
				const dd = pad(date.getDate());
				const HH = pad(date.getHours());
				const mm = pad(date.getMinutes());
				const ss = pad(date.getSeconds());
				
				return `${yyyy}${MM}${dd}${HH}${mm}${ss}`;
			},
			countDown(time, timeout) {
				// 清理旧的定时器
				if (this.countTimer) {
					clearInterval(this.countTimer);
					this.countTimer = null;
				}
				// 解析时间字符串
				let startTime;
				if (time.includes('T')) {
					// ISO 格式时间，直接解析
					startTime = new Date(time);
				} else {
					// 其他格式，使用替换方法
					startTime = new Date(time.replace(/-/g, '/').replace('T', ' '));
				}
				// 验证时间是否有效
				if (isNaN(startTime.getTime())) {
					this.countDownTime = ['00', '00', '00'];
					this.countTimer = null;
					return;
				}
				const endTime = startTime.getTime() + timeout * 60 * 1000;
				const now = util.realNowTime() // 获取服务器时间
				this.TimeExpire = this.yyyyMMddHHmmss(endTime)
				// 如果已经超时
				if (now >= endTime) {
					this.countDownTime = ['00', '00', '00'];
					this.countTimer = null;
					return;
				}
				// 立即计算一次剩余时间
				this.updateCountDownTime(endTime, timeout);
				// 设置定时器
				this.countTimer = setInterval(() => {
					this.updateCountDownTime(endTime, timeout);
				}, 1000);
			},
			// 新增辅助方法：更新倒计时显示
			updateCountDownTime(endTime, timeout) {
				const now = util.realNowTime() // 获取服务器时间
				let diff = endTime - now;
				if (diff <= 0) {
					this.countDownTime = ['00', '00', '00'];
					if (this.countTimer) {
						clearInterval(this.countTimer);
						this.countTimer = null;
					}
					return;
				}else if(diff > timeout * 60 * 1000){
					diff = timeout * 60 * 1000
				}
				const hours = Math.floor(diff / (1000 * 60 * 60));
				const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
				const seconds = Math.floor((diff % (1000 * 60)) / 1000);
				const format = (n) => (n < 10 ? '0' + n : n.toString());
				this.countDownTime = [format(hours), format(minutes), format(seconds)];
			},
			detectBrowser() {
				const ua = navigator.userAgent.toLowerCase()
				this.isWeChatBrowser = ua.indexOf('micromessenger') > -1
				this.isAPPBrowser = ua.indexOf('dtbusiness') > -1
				this.setPayList()
			},
			setPayList() {
				// 始终显示支付宝选项，但在微信中会引导用户到外部浏览器
				this.payList = [
					{ payChannel: 'wechat', src: wechat, text: '微信' },
					{ payChannel: 'alipay', src: alipay, text: '支付宝' },
					{ payChannel: 'together', src: manyPay, text: '支持微信、支付宝、云闪付扫码支付' },
					{ payChannel: 'union', src: unionpay, text: '单笔订单超20000元建议使用银联支付' }
				]
			},
			swtichPayChannel(channel) {
				this.payChannel = channel
			},
			remaining: function () {
				let hour = parseInt(this.countNum / 3600);
				if (hour < 10) {
					hour = "0" + hour;
				}
				let minute = parseInt((this.countNum % 3600) / 60);
				if (minute < 10) {
					minute = "0" + minute;
				}
				let second = parseInt(this.countNum % 60);
				if (second < 10) {
					second = "0" + second;
				}
				return { hour, minute, second };
				//return hour + " : " + minute + " : " + second;
			},
			getOrderStatusStr(val,status){
				const statusTag = {
					cancel:'cancel',
					pay:'success',
					complete:'warning',
					used:'warning'
				}
				const statusStr = {
					cancel:'已取消',
					pay:'已支付',
					complete:'已确认',
					used:'已使用'
				}
				if(val == 'tag') return statusTag[status?.toLowerCase()]
				if(val == 'text') return statusStr[status?.toLowerCase()]
			},
			getRoomImage(orders) {
				return (orders.find(item => item.RoomImage) || {}).RoomImage || null
			},
			refreshCountDown() {
				const createTime = this.orders?.[0]?.CreateTime
				if (!createTime || !this.unpayTimeoutMinutes) return
				this.countDown(createTime, Number(this.unpayTimeoutMinutes))
			},
			async resumePageState() {
				// 避免 pageshow/visibilitychange/activated 同时触发造成重复请求
				if (this.isResumingFromReturn) return
				if (!this.$route || this.$route.path !== '/meeting/payment') return
				this.isResumingFromReturn = true
				try {
					await this.initData()
				} finally {
					this.isResumingFromReturn = false
				}
			},
			async initData(){
				// this.orders = await this.getReservationOrdersAction({
				// 	BookingId: this.$route.query?.code
				// });
				// this.orders = ss_006.filter(item => item.OrderStatus.toLowerCase() == "unpay");
				// SS_020传vipno、payChannel：together、bookingId：订单Id
				// let SS_020 = await this.getQRcodeAction({
				// 	payChannel:'together',
				// 	bookingId: this.$route.query?.code
				// });
				// if(SS_020){
				// 	if(SS_020.Status == 1){
				// 		// this.showPayCode = true
				// 		this.QRImg = SS_020.QRCode
				// 	}else{
				// 		this.$Modal.warning({
				// 			title: "支付失败",
				// 			content: SS_020.Message,
				// 		});
				// 	}
				// }
				if(this.$route.query?.code) sessionStorage.setItem('BookingId', this.$route.query?.code);
				let ss_007 = await this.getReservationDetailAction({
					BookingId:this.$route.query?.code
				})
				if(ss_007 && ss_007.length){
					this.orders = ss_007.filter(item => item.OrderStatus?.toLowerCase() == "unpay");
					if (!this.orders.length) {
						this.$router.replace('/meeting/orders')
						return
					}
					this.orderno = this.orders[0]?.OrderNo
					this.StoreName = this.orders[0]?.StoreName
					let ss_012 = await this.getMeetingOrderTimeAction({ParentCode: 'dt_ss_roomorder_time',Code: 'dt_ss_unpay_order_timeout_time'})
					this.unpayTimeoutMinutes = Number(ss_012) || 0
					this.countDown(this.orders[0].CreateTime, this.unpayTimeoutMinutes)
				}else{
					this.$router.replace('/meeting/orders')
				}
			},
			goResult(){
				this.$router.push('/vipmeeting/payresult')
			},
			isTest(){
				return process.env.VUE_APP_INNERNODE_ENV == 'development' || process.env.VUE_APP_INNERNODE_ENV == 'stage' || process.env.VUE_APP_INNERNODE_ENV == 'qa'
			},
			async goPay() {
				if (this.loading) return
				// 微信环境中选择支付宝，显示引导页面
				if (this.isWeChatBrowser && this.payChannel === 1) {
					this.showAlipayGuide = true
					return
				}
				
				const canProceed = await this.forOrderStatus(this.orderno, this.payChannel) // 查询支付状态
				// 如果订单状态不是 unpay，则不进入下一步发起支付
				if (!canProceed) return
				
				if (this.payChannel === 'union') {
					// 银联支付
					location = `${cvoUrl}/Public/Pay/SF/Pay.aspx?order_no=${this.orderno}&pc_no=${this.userInfo?.VipNo}&app=Room`;
				} else if (this.payChannel === 'alipay') {
					// 支付宝（APP环境）
					let AliPaySrc = `${cvoUrl}/Public/Pay/AliPay/AliPagePay.aspx?orderno=${this.orderno}&app=Room`;
					if(this.isAPPBrowser){
						window.ReactNativeWebView.postMessage(JSON.stringify({
							action: 'openLink',
							path: AliPaySrc,
						}))
					}else{
						// 支付宝（非微信环境）
						location = AliPaySrc
					}
				} else if (this.payChannel === 'wechat') {
					// 微信支付
					await this.handleWechatPay()
				} else {
					this.loading = true // 按钮加载
					// 聚合支付
					await this.handleMultiPay()
				}
			},
			// 复制到剪贴板
			copyToClipboard() {
				const alipayUrl = `${cvoUrl}/Public/Pay/AliPay/AliPagePay.aspx?orderno=${this.orderno}&app=Room`
				const textArea = document.createElement('textarea')
				textArea.value = alipayUrl
				document.body.appendChild(textArea)
				textArea.select()
				try {
					document.execCommand('copy')
					this.$Message.success('链接已复制到剪贴板，请在浏览器中打开')
				} catch (err) {
					this.$Message.error('复制失败，请手动复制链接')
				}
				document.body.removeChild(textArea)
			},
			// 关闭支付宝引导
			closeAlipayGuide() {
				this.showAlipayGuide = false
			},
			// 其他支付方式处理保持不变
			async handleWechatPay() {
				let order = {
					orderNo: this.orderno + '_Room',
					body: 'Life Center Conference Room Reservation',
					amount: this.amount,
					productId: this.orderno,
				}
				if (this.isTest()) order.amount = 0.01
				const sign_arr = Object.keys(order).sort().map(key => `${key}=${order[key]}`)
				const sign = sign_arr.join('&').MD5(32)
				const notifyUrl = `${cvoUrl}/pay/Receive.aspx`
				const payresultUrl = `${baseUrl}/Client/index.html#/meeting/payresult`
				location = `${ambaseUrl}/xh/index.html#/micepay?orderNo=${order.orderNo}&body=${decodeURIComponent(order.body)}&amount=${order.amount}&productId=${order.productId}&key=${sign}&timeExpire=${this.TimeExpire}&notifyUrl=${encodeURIComponent(notifyUrl)}&redirect=${encodeURIComponent(payresultUrl)}`
			},
			async handleMultiPay() {
				let ss_020 = await this.getQRcodeAction({
					payChannel: 'together',
					bookingId: this.$route.query?.code
				})
				this.loading = false
				if (ss_020 && ss_020.Status == 1 && ss_020.QRCode) {
					this.QRImg = ss_020.QRCode
					this.showPayCode = true
					// this.beginfor(this.orderno, 'together')
				} else {
					this.$Modal.error({
						title: "支付失败",
						content: ss_020?.Message || "支付发生异常，请重新尝试"
					})
				}
			},
			// async goPay() {
			// 	if(this.loading) return
			// 	if (this.payChannel == 3) {
			// 		// 银联支付
			// 		location = `${cvoUrl}/Public/Pay/SF/Pay.aspx?order_no=${this.orderno}&pc_no=${this.userInfo?.VipNo}&app=Room`;
			// 	} else if (this.payChannel == 1) {
			// 		// 支付宝
			// 		location = `${cvoUrl}/Public/Pay/AliPay/AliPagePay.aspx?orderno=${this.orderno}&app=Room`;
			// 	} else if (this.payChannel == 20) {
			// 		// 微信（香荟）
			// 		let order = {
			// 			orderNo:this.orderno + '_Room',
			// 			body:'Life Center Conference Room Reservation', // 会议名称
			// 			amount:this.amount,
			// 			productId:this.orderno, // 商品ID
			// 		}
			// 		if(this.isTest()) order.amount = 0.01; // 测试环境支付固定为一分钱
					
			// 		const sign_arr = Object.keys(order).sort().map(key => `${key}=${order[key]}`)
			// 		const sign = sign_arr.join('&').MD5(32)
			// 		const notifyUrl = `${cvoUrl}/pay/Receive.aspx`;
			// 		const payresultUrl = `${baseUrl}/Client/index.html#/meeting/payresult`;
					
			// 		location = `${ambaseUrl}/xh/index.html#/micepay?orderNo=${order.orderNo}&body=${decodeURIComponent(order.body)}&amount=${order.amount}&productId=${order.productId}&key=${sign}&notifyUrl=${encodeURIComponent(notifyUrl)}&redirect=${encodeURIComponent(payresultUrl)}`
			// 	} else {
			// 		this.loading = true
			// 		var app = "sftogether";
			// 		if (this.payChannel == 2) {
			// 			app = "sfwechat";
			// 		} else if (this.payChannel == 1) {
			// 			app = "sfalipay";
			// 		} else if (this.payChannel == 20) {
			// 			app = "wechat";
			// 		} else if (this.payChannel ==  5) {
			// 			app = "DH";
			// 		}
			// 		let ss_020 = await this.getQRcodeAction({
			// 			// vipno:this.userInfo?.VipNo,
			// 			payChannel:'together',
			// 			bookingId: this.$route.query?.code
			// 		});
			// 		this.loading = false
			// 		// let response = await this.unionPayAction({
			// 		// 	order_no: this.$route.query.no,
			// 		// 	orderno_tip: this.$route.query.no,
			// 		// 	pc_no: this.userInfo?.VipNo,
			// 		// 	app,
			// 		// });
			// 		if (ss_020 && ss_020.Status == 1 && ss_020.QRCode) {
			// 			this.QRImg = ss_020.QRCode
			// 			this.showPayCode = true;
			// 			this.beginfor(this.orderno,app);
			// 		} else if (ss_020) {
			// 			this.$Modal.error({
			// 				title: "支付失败",
			// 				content: ss_020.Message,
			// 			});
			// 		} else {
			// 			this.$Modal.error({
			// 				title: "支付失败",
			// 				content: "支付发生异常，请重新尝试",
			// 			});
			// 		}
			// 	}
			// },
			colse() {
				this.showPayCode = false;
				clearInterval(this.ajaxpay);
			},
			beginfor(orderNo,payChannel) {
				var vm = this;
				clearInterval(this.ajaxpay);
				this.ajaxpay = setInterval(function () {
					vm.forOrderStatus(orderNo,payChannel);
				}, 1000); // 每间隔一秒执行一次
			},
			async forOrderStatus(orderNo,payChannel) {
				let SS_022 = await this.getMeetingOrderStatusAction(orderNo);
				if (SS_022) {
					const orderStatus = SS_022.OrderStatus?.toLowerCase()
					if (orderStatus == "pay") {
						this.showPayCode = false
						clearInterval(this.ajaxpay);
						// this.SAVE_USER_TIME();
						// this.SET_ORDERSTATUS(SS_022);
						this.$router.push({ 
							path: '/meeting/payresult',
							query: {code: 1, v_oid: orderNo, v_amount: SS_022.FeedBackAmount, payChannel: payChannel, v_orderdate: SS_022.FeedBackDate}
						})
						return false
					}
					if(orderStatus == "cancel"){
						this.$Modal.error({
							title: "订单已取消",
							content: SS_022.Message,
							onOk: () => {
								this.$router.push('/meeting/orders')
							}
						})
						return false
					}
					if(orderStatus != "unpay"){
						this.$router.push('/meeting/orders')
						return false
					}
				}
				this.beginfor(orderNo,payChannel);
				return true
			},
		},
		beforeDestroy: function () {
			clearInterval(this.ajaxpay);
			this.ajaxpay = null
			clearInterval(this.countTimer);
			this.countTimer = null
			if (this.pageShowHandler) {
				window.removeEventListener('pageshow', this.pageShowHandler)
				this.pageShowHandler = null
			}
			if (this.visibilityHandler) {
				document.removeEventListener('visibilitychange', this.visibilityHandler)
				this.visibilityHandler = null
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/mixin';
	.root {
		display:block;
		background-color: #eee;
	}
	.container {
		background-color: #eee;
		padding-top:1rem;
		margin: auto;
		max-width: 1400px;
		padding-right: 6px;
		padding-left: 6px;
	}
	.header {
		display:flex;
		background-color: white;
		padding:30px;
		border-radius: 20px;
		position: relative;
		.room-img {
			width:150px;
			height:150px;
			border-radius: 20px;
			object-fit: cover;
		}
		.order-desc {
			display:flex;
			margin-bottom: 10px;
			.meeting-room,.timerange {
				margin-right: 20px;
			}
			.money {
				color:red;
			}
			.cancel,.success,.warning{
				@include fontSize($font-size-12);
				width:60px;
				color: $warning-color;
				border:1px solid $warning-color;
				text-align: center;
				border-radius: 20px;
				height: 0.2rem;
				line-height: 0.2rem;
				margin-left: 10px;
			}
			.success{
				color: $success-color;
				border:1px solid $success-color;
			}
			.warning{
				color: $warning-color;
				border:1px solid $warning-color;
			}
			.cancel{
				cursor: no-drop;
				color: #c5c8ce;
				border-color: #dcdee2;
			}
		}
		.h-middle {
			margin-left: 20px;
			flex:1;
			@include fontSize($font-size-16);
		}
		.countDown{
			@include fontSize($font-size-16);
			position: absolute;
			left: 50%;
			top: 38px;
			transform: translateX(-50%);
			span{
				background-color: #bc86c8;
				padding: 6px;
				color: #ffffff;
				margin: 0 4px;
			}
		}
		.h-right {
			margin-left: 20px;
			display:flex;
			align-items: center;
			justify-content: center;
			@include fontSize($font-size-24);
			.total {
				color:red;
				font-weight: bold;
				margin-left: 10px;
			}
		}
		.meeting-center {
			@include fontSize($font-size-24);
			margin-bottom: 10px;
		}
	}
	.payList {
		background-color: white;
		padding: 30px;
		margin-top: 30px;
		border-radius: 20px;
		.item {
			cursor: pointer;
			padding: 10px 0;
			//clear: both;
			overflow: hidden;
			position: relative;
			border-bottom: 1px solid #dedede;
			&:first-child{
				border-top: 1px solid #dedede;
			}
			// &:not(:last-child){
			// 	border-bottom: 1px solid #dedede;
			// }
			.left {
				float: left;
				img {
					width: 50px;
				}
				b {
					padding-left: 10px;
					position: relative;
					top: -15px;
				}
			}
			.right {
				float: right;
				width: 25px;
				position: absolute;
				top: 50%;
				right: 10px;
				transform: translateY(-50%);
			}
		}
	}
	.bottom {
		display:flex;
		margin:30px 0;
		justify-content: center;
		.pay-btn {
			width:330px;
			border-radius: 30px;
			height:50px;
		}
	}
	.qrcode-bg {
		position: absolute;
		width: 100%;
		height: 100%;
		background-color: #ffffff;
		z-index: 2000;
		.desc {
			top: 30px;
			min-width: 100%;
			padding: 2VW;
			display: flex;
			flex-direction: column;
			justify-content: center;
			background-color: #ffffff;
			.top{
				text-align: center;
				justify-content: center;
				& > p {
					@include fontSize($font-size-18);
					font-weight: bold;
					color: #636363;
					text-rendering: optimizeSpeed;
					font-style: normal;
					b {
						@include fontSize($font-size-30);
						vertical-align: middle;
						color: #bc86c8;
						margin: 0 10px;
						position: relative;
						top: -5px;
					}
				}
			}
			.main{
				display: flex;
				margin: 30px auto;
				.qrcode {
					margin: 10px auto;
					display: block;
					max-width: 300px;
					text-align: center;
					img{
						width: 100%;
					}
					.qrcode-desc {
						width: 100%;
						// height: 58px;
						background-color: #bc86c8;
						line-height: 22px;
						color: #ffffff;
						text-align: center;
						font-weight: 700;
						@include fontSize($font-size-15);
						line-height: 30px;
						margin-top: 20px;
						b {
							@include fontSize($font-size-13);
							font-weight: 500;
						}
					}
				}
				.p-w-sidebar {
					width: 380px;
					height: 420px;
					background: url('../../assets/order/phone-bg.png') 50px 0 no-repeat;
					&.alipay {
						background: url('../../assets/order/phone-alipay-bg.png') 50px 0 no-repeat;
					}
					&.jhzf {
						background: url('../../assets/order/phone-jhzf-bg.png') 50px 0 no-repeat;
					}
				}
			}
		}
		.close {
			position: fixed;
			top: 30px;
			right: 30px;
		}
	}
	// 支付宝引导页面样式
	.alipay-guide {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.8);
		z-index: 3000;
		display: flex;
		align-items: center;
		justify-content: center;
	
		.guide-content {
			background: white;
			border-radius: 12px;
			width: 90%;
			max-width: 500px;
			max-height: 90vh;
			overflow-y: auto;
			.guide-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 20px;
				border-bottom: 1px solid #eee;
				h3 {
					margin: 0;
					color: #333;
				}
				.close-btn {
					font-size: 24px;
					color: #999;
					cursor: pointer;
					width: 30px;
					height: 30px;
					text-align: center;
					line-height: 30px;
					
					&:hover {
						color: #333;
					}
				}
			}
			
			.guide-body {
				padding: 20px;
				.step-section {
					margin-bottom: 30px;
					
					.step-item {
						display: flex;
						align-items: flex-start;
						margin-bottom: 20px;
						.step-number {
							background: #bc86c8;
							color: white;
							width: 24px;
							height: 24px;
							border-radius: 50%;
							text-align: center;
							line-height: 24px;
							margin-right: 15px;
							flex-shrink: 0;
						}
						.step-content {
							flex: 1;
							h4 {
								margin: 0 0 5px 0;
								color: #333;
							}
							p {
								margin: 0;
								color: #666;
								font-size: 14px;
							}
						}
					}
				}
				.action-buttons {
					display: flex;
					flex-direction: column;
					gap: 12px;
					margin-bottom: 20px;
					.guide-btn {
						width: 100%;
						border-radius: 6px;
						&.secondary {
							background: #f5f5f5;
							color: #333;
							border: 1px solid #d9d9d9;
						}
					}
				}
				.order-info {
					background: #f9f9f9;
					padding: 15px;
					border-radius: 6px;
					p {
						margin: 5px 0;
						color: #666;
						strong {
							color: #333;
						}
					}
				}
			}
		}
	}
	@media (max-width: 768px){
		.container {
			padding-top: 2.4rem;
		}
		.header {
			padding:0px;
			padding-bottom: 10px;
			position:relative;
			flex-direction: column;
			.room-img {
				width:100%;
				height:150px;
				border-radius: 20px;
				object-fit: cover;
			}
			.meeting-center {
				margin-top: 10px;
				font-size: 14px;
			}
			.orderno{
				font-size: 14px;
			}
			.order-desc {
				.meeting-room,.timerange {
					margin-right: 10px;
					font-size: 14px;
				}
				
			}
			.countDown{
				font-size: 16px;
				position: static;
				transform: translateX(0%);
				padding: 20px 0 10px 0;
				text-align: center;
			}
			.h-right {
				justify-content: flex-start;
				font-size: 16px;
				margin-top: 10px;	
			}
		}
		.qrcode-bg {
			.desc {
				margin-top: 80px;
				.top{
					text-align: center;
					justify-content: center;
					& > p {
						font-size: 16px;
						b {
							font-size: 20px;
						}
					}
				}
				.main{
					display: flex;
					flex-direction: column;
					margin: 10px auto;
					.qrcode {
						margin: 10px auto;
						max-width: 240px;
						.qrcode-desc {
							font-size: 12px;
							margin-top: 0px;
							b {
								font-size: 12px;
							}
						}
					}
					.p-w-sidebar {
						display: none;
					}
				}
			}
			.close {
				position: fixed;
				top: 10px;
				right: 10px;
			}
		}
		// 支付宝支付引导
		.alipay-guide {
			.guide-content {
				width: 95%;
				margin: 20px;
				.guide-body {
					padding: 15px;
					.action-buttons {
						.guide-btn {
							height: 44px;
							font-size: 16px;
						}
					}
				}
			}
		}
	}
</style>